// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Import all controllers manually for esbuild
import AceEditorController from "./ace_editor_controller"
import DashboardMenuController from "./dashboard_menu_controller"
import EditFormController from "./edit_form_controller"
import HelloController from "./hello_controller"
import HomepageMenuController from "./homepage_menu_controller"
import MyToggleController from "./my_toggle_controller"
import PreviewController from "./preview_controller"

application.register("ace-editor", AceEditorController)
application.register("dashboard-menu", DashboardMenuController)
application.register("edit-form", EditFormController)
application.register("hello", HelloController)
application.register("homepage-menu", HomepageMenuController)
application.register("my-toggle", MyToggleController)
application.register("preview", PreviewController)

import { Dropdown, Modal, Tabs, Popover, Toggle, Slideover, Alert } from "tailwindcss-stimulus-components"
application.register('dropdown', Dropdown)
application.register('modal', Modal)
application.register('tabs', Tabs)
application.register('popover', Popover)
application.register('toggle', Toggle)
application.register('slideover', Slideover)
application.register('alert', Alert)
